import AnaliticaFantasyIcon from '@/components/shared/icons/analitica-fantasy-icon';
import BiwengerIcon from '@/components/shared/icons/biwenger-icon';
import FantasyLaLigaIcon from '@/components/shared/icons/fantasy-la-liga-icon';
import FantasyMarcaIcon from '@/components/shared/icons/FantasyMarcaIcon';
import MisterFantasyIcon from '@/components/shared/icons/MisterFantasyIcon';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import { FANTASY } from '@/helpers/biwenger-helper';
import { Box } from '@mui/material';
import { useContext } from 'react';

const defaultSize = 24;

const fantasyOptions = [
    {
        label: 'Analítica Fantasy',
        value: FANTASY.ANALITICA,
        icon: (size = defaultSize) => <AnaliticaFantasyIcon width={size} styles={{ borderRadius: '50%' }} />,
    },
    {
        label: 'La Liga Fantasy',
        value: FANTASY.FANTASY,
        icon: (size = defaultSize) => <FantasyLaLigaIcon iconWidth={size} iconHeight={size} />,
    },
    {
        label: 'Fantasy Biwenger',
        value: FANTASY.BIWENGER,
        icon: (size = defaultSize) => <BiwengerIcon width={size} height={size} />,
    },
    {
        label: 'Fantasy Marca',
        value: FANTASY.FANTASY_MARCA,
        icon: (size = defaultSize) => <FantasyMarcaIcon width={size} height={size} />,
    },
    {
        label: 'Mister Fantasy',
        value: FANTASY.MISTER_FANTASY,
        icon: (size = defaultSize) => <MisterFantasyIcon width={size} height={size} />,
    },
];

const LineupFantasySelector = ({ size = defaultSize }) => {
    const { state, dispatch } = useContext(Context);
    const fantasy = state.preferences.fantasy;

    const handleClick = (value) => {
        dispatch({ type: REDUCERS.UPDATE_PREFERENCES, payload: { fantasy: value } });
    };

    return (
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            {fantasyOptions.map((option) => {
                const isSelected = fantasy === option.value;
                return (
                    <CustomTooltip key={option.value} label={option.label}>
                        <Box
                            sx={{
                                cursor: 'pointer',
                                opacity: isSelected ? 1 : 0.35,
                            }}
                            onClick={() => handleClick(option.value)}
                        >
                            {option.icon(size)}
                        </Box>
                    </CustomTooltip>
                );
            })}
        </Box>
    );
};

export default LineupFantasySelector;
